import React from 'react'
import StudentEnquiryForm from '../commonfile/StudentEnquiryForm'

const ZoneHeadEnquiryForm = () => {
  return  <StudentEnquiryForm/>
}

export default ZoneHeadEnquiryForm